import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/solid";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const Breadcrumbs = () => {
    const location = useLocation();

    const breadcrumbs = useReactRouterBreadcrumbs();

    if (breadcrumbs.length <= 2) {
        return null;
    }

    return (
        <div className={
            "2xl:col-span-7 lg:col-span-6 col-span-full grid-cols-8 content-start rounded-lg mt-6 " +
            "flex flex-row items-center font-medium capitalize "
        }>
            {breadcrumbs.slice(1).map(({ breadcrumb }, index) => {
                if (index === breadcrumbs.length - 1) {
                    return (
                        <div className={"flex flex-row items-center"} key={index}>
                            {index !== 0 &&
                                <span className={"inline-block mx-1"}>
                                    <ChevronRightIcon className="text-blue-gray-600 block h-5 w-5" />
                                </span>
                            }
                            <span
                                className={"text-blue-gray-500 hover:text-primary-700"}
                                key={index}>
                                {breadcrumb.props.children.replaceAll("-", " ")}
                            </span>
                        </div>
                    );
                }
                return (
                    <div className={"flex flex-row items-center"} key={index}>
                        {index !== 0 &&
                            <span className={"inline-block mx-1"}>
                                <ChevronRightIcon className="text-blue-gray-600 block h-5 w-5" />
                            </span>
                        }
                        {breadcrumb.key !== location.pathname ?
                            <Link
                                className="underline text-blue-gray-500 hover:text-blue-gray-700"
                                to={breadcrumb.key}
                                key={index}>
                                {breadcrumb.props.children.replaceAll("-", " ")}
                            </Link> :
                            <span
                                className={"text-blue-gray-600"}
                                key={index}>
                                {breadcrumb.props.children.replaceAll("-", " ")}
                            </span>
                        }
                    </div>
                );
            })}
        </div >
    );
};

export default Breadcrumbs;
